import { render, staticRenderFns } from "./TechnicianForDispatcher.vue?vue&type=template&id=df466506&"
import script from "./TechnicianForDispatcher.vue?vue&type=script&lang=js&"
export * from "./TechnicianForDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports